import { TableCellColor } from '../../ui/models/table-cell-color';
import { PromotionMechanic } from './promotion-mechanic';

export type Promotion = {
  id: string;
  name: string;
  type: string;
  prizes: string;
  prizeDescription: string;
  country: string;
  startDate: Date;
  endDate: Date;
  expirationDate: Date;
  auditDueDate: Date;
  agencyStatus: string;
  auditStatus: AuditStatus;
  auditStatusLabel: string;
  promotionStatus: PromotionStatus;
  promotionStatusLabel: string;
  promoType: NGPSPromoType;
  goLiveDate: Date | null;
  sunsetDate: Date | null;
  updatedAt: Date;
  promotionUrl: string | null;
  prizesDescription: string | null;
  cdsPromoId: string | null;
  promotionRegulation?: PromotionRegulation[];
  promotionMechanic?: PromotionMechanic;
  timeZone?: string;
};

export type PromotionRegulation = {
  id: number;
  container: string;
  blobName: string;
  createdAt: Date;
};

export type UpdatePromotionUrl = {
  promotionId: string;
  promotionUrl: string | null;
};

export type UpdatePromotionPrizes = {
  promotionId: string;
  promotionPrizes: string | null;
};

export type UpdatePromotionData = {
  promotionId: string;
  cdsPromoId: string | null;
  goLiveDate?: Date;
  sunsetDate?: Date;
  promotionMechanicId?: string;
};

export enum AuditStatus {
  UPCOMING = 'UPCOMING',
  READY = 'READY',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
}

export enum PromotionStatus {
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
}

export enum NGPSPromoType {
  PRIZE_DRAW = 'Prize Draw',
  INSTANT_WIN_WINNING_MOMENTS = 'Instant Win (Always Win)',
}

export const AuditStatusColors: Record<AuditStatus, TableCellColor> = {
  UPCOMING: TableCellColor.yellow,
  ACTIVE: TableCellColor.green,
  READY: TableCellColor.blue,
  CLOSED: TableCellColor.red,
};

export const PromotionStatusColors: Record<PromotionStatus, TableCellColor> = {
  UPCOMING: TableCellColor.yellow,
  ACTIVE: TableCellColor.green,
  CLOSED: TableCellColor.red,
};
export interface PromotionSummary {
  [key: number]: number;
}

export interface userPromotionNote {
  id: string;
  text: string;
  promotionId: string;
  userId: string;
}

export interface userPromotionComment {
  id: string;
  comment: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
  participationId: string;
}